import type { TaskDetail } from '@hygge/shared';

export interface EpicProgress {
  total: number;
  done: number;
  pct: number; // 0-100, integer
}

/**
 * Aggregate completion progress over a parent task's sub-issues.
 * A child counts as done when its status category is 'done'.
 */
export function computeEpicProgress(children: TaskDetail['children']): EpicProgress {
  const total = children.length;
  const done = children.filter((c) => c.status?.category === 'done').length;
  const pct = total === 0 ? 0 : Math.round((done / total) * 100);
  return { total, done, pct };
}
